<div class="formProgress">
  @if (total > 0) {
    <div class="formProgressHead">
      <span class="formProgressDot" aria-hidden="true"></span>
      <span class="formProgressLabel">{{ 'INPUTS.TICKET_PROGRESS' | translate: { current: current, total: total } }}</span>
    </div>
    <div class="formProgressTrack" role="progressbar" [attr.aria-valuenow]="current" aria-valuemin="1" [attr.aria-valuemax]="total">
      <span class="formProgressBar" [style.width.%]="percentage"></span>
    </div>
  }
  @if (note) {
    <p class="formProgressNote">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 16v-5M12 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
      </svg>
      <span>{{ note }}</span>
    </p>
  }
</div>
